import { Box, makeStyles } from '@material-ui/core';
import { Currency, getMoneySymbolByCurrency } from '@nemuru-eng/js-api-client';
import { ReactNode } from 'react';

import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { CustomPalette } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

const useStyles = makeStyles((theme) => ({
  amount: ({ palette }: { palette: CustomPalette }) => ({
    '& .MuiInputBase-input': {
      fontSize: `${theme.typography.h3.fontSize} !important`,
      fontWeight: `${theme.typography.fontWeightBold} !important`,
      color: `${palette.text.title} !important`,
      textAlign: 'right',
    },
  }),
}));

interface VehicleAmountFieldProps {
  currency: Currency;
  disabled?: boolean;
  highlightLabel?: boolean;
  children?: ReactNode;
}

export const VehicleAmountField = ({ currency, disabled, highlightLabel, children }: VehicleAmountFieldProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const classes = useStyles({ palette });

  return (
    <Box display="flex" justifyContent="flex-end">
      <Box width="50%">
        <Box bgcolor={palette.grey[50]} borderRadius={customBorderRadius.paper} py={2} px="12px">
          <NumberFormField
            name="item.price"
            valueUnit={getMoneySymbolByCurrency(currency)}
            label="VEHICLE_AMOUNT"
            fieldVariant={FieldVariant.form}
            disabled={disabled}
            highlightLabel={highlightLabel}
            className={classes.amount}
          />
          {children && <Box>{children}</Box>}
        </Box>
      </Box>
    </Box>
  );
};
